import { useCallback } from 'react';
import { To } from 'react-router-dom';

import useLocalizedResolveTo from './useLocalizedResolveTo.js';
import useResolveToWithSearch from './useResolveToWithSearch.js';

export interface ResolveToOptions {
  keepSearchParams?: boolean;
  lang?: string | null;
}

/**
 * resolveTo with and current location.search by context and language
 */
export const useResolveTo = () => {
  const resolveToWithSearch = useResolveToWithSearch();
  const localizedResolveTo = useLocalizedResolveTo();

  return useCallback(
    (to: To, opts?: ResolveToOptions) => {
      return resolveToWithSearch(localizedResolveTo(to, opts?.lang), opts?.keepSearchParams);
    },
    [localizedResolveTo, resolveToWithSearch]
  );
};

export default useResolveTo;
